import React from "react";
import List from "../components/MarketPlace/List";
import { Heading } from "../components/MarketPlace/Heading";

export default function Discover() {
  return (
    <div>
      <Heading />
      <List />
    </div>
  );
}
